import React, { useEffect, useState } from 'react'
import Contact from '../components/ContactUs/Contact';
import CustomizedSnackbar from '../components/CustomizedSnackbars/CustomizedSnackbar';
import Footer from '../components/Footer/Footer';
import FooterMobile from '../components/Footer/FooterMobile';
import HeroBusiness from '../components/HeroLandingPage/HeroBusiness';
import Navbar from '../components/Navbar/Navbar';
import SetupStepRealEstate from '../components/SetupSteps/SetupStepRealEstate';
import HeroImage from '../assets/images/ML_business_servises_relocation_1_screen.jpg'
import Image from "../assets/images/real_estate_value.png";
import BusinessMessage from '../components/BusinessMessage/BusinessMessage';

import Step1 from '../assets/images/Step1.svg'
import Step2 from '../assets/images/RentalMarketing.svg'
import Step3 from '../assets/images/MarketResearch.svg'
import Step4 from '../assets/images/PropertyValuation.svg'
import Step5 from '../assets/images/Regulatoryguidance.svg'
import Step6 from '../assets/images/TransactionClosing.svg'

const TabletBreakpoint = 1024;
const text = [
  {text:'Property Search and Selection',img:Step1}, 
  {text:'Rental Property Marketing',img:Step2},
  {text:'Market Research and Analysis',img:Step3},
  {text:'Property Valuation and Negotiation',img:Step4},
  {text:'Legal and regulatory guidance',img:Step5},
  {text:'Personalized Solutions and Portfolio Optimization',img:Step6}
  ]
const BusinessRentBuy = () => {
    const [offset, setOffset] = useState(0);
  const [width, setWidth] = useState(window.innerWidth)
  const [background,setBackground] = useState('transparent')
  useEffect(()=>{
    window.addEventListener("resize", () => setWidth(window.innerWidth));
    window.scrollTo(0, 0)
  },[])
  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
    
}, []);
useEffect(()=>{
  if (offset>100) setBackground('#12284C')
  else setBackground('transparent')
},[offset])
  return (
    <div>
      <Navbar background={background}/>
      <HeroBusiness heroImage={HeroImage}
      header='We provide top notch advisory on real estate!'
      desc='With professional advice from our reliable advisory services, you may maximize the potential of your real estate endeavors.'
      />
      <BusinessMessage
      img={Image}
      header='Add value to your real estate portfolio'
      desc="Welcome to Modern Living, your premier destination for real estate buy and rent services. We specialize in helping you find the perfect property to meet your needs, whether you're looking for a place to call home or seeking an investment opportunity in the rental market.$We understand that finding the right property to buy or rent can be a difficult task. That's why our dedicated team of real estate experts is here to guide you through the process, making it smooth, efficient, and tailored to your preferences."
      desc2={"Our vast understanding of the local property market and our broad database of available properties enable us to connect you with ones that perfectly match your preferred location, financial capacity, and way of life. We offer an extensive selection of accommodations that cater to individuals seeking a comfortable apartment, families in search of a larger home, or businesses requiring commercial properties.\n\nOur knowledgeable agents will collaborate closely with you to comprehend your unique needs and aspirations for investing. We will furnish you with all-encompassing details regarding the available properties, incorporating thorough explanations, visuals, and significant highlights. We will support you in organizing property visits and obtaining favorable terms through negotiations to guarantee that you make an informed choice.\n\nAs a component of our purchasing and rent service, we provide valuable perspectives on rental market patterns and potential ROI. We will examine various factors like demand for rental properties, property value increase, and community trends in order to assist you in recognizing investment properties that possess the potential for generating profitable rental earnings.\n\nOur dedication extends beyond the acquisition of the real estate. We offer continuous assistance and direction to ensure a smooth transition to the rental market. Our team is able to lend a hand with promoting your property, identifying appropriate tenants, and skillfully overseeing the rental process. Our objective is to increase your rental revenue while minimizing the inconvenience and strain linked to managing your property.\n\nIf you have either prior experience in investing or are a newbie in purchasing property, rely on Modern Living as your dependable associate for real estate purchase and rental services. Allow us to assist you in discovering the ideal property and unleashing the full potential of your investment. Begin your path towards profitable real estate ownership and rental revenue by reaching out to us today."}
      />
        <SetupStepRealEstate data={text}/>
        <Contact displaymsg='block' displayupload = 'none'/>
        {width < TabletBreakpoint?<FooterMobile/>:<Footer/>}
        <CustomizedSnackbar/>
    </div>
  )
}

export default BusinessRentBuy;